module.exports = __webpack_public_path__ + "img/time-red.44482986.svg";